import React from "react";
import Footer from "../components/layout/Footer";
import Navbar from "../components/layout/Navbar";
import man from "../assets/img/e7f972066a.jpeg";
import PlanButtons from "../components/PlanButtons";

function ForBusiness() {
  return (
    <div class="main-container">
      <Navbar />
      <div class="first-banner col-12 col-lg-11 ml-lg-5 d-flex">
        <div class="col-md-6 mr-auto d-none d-md-block">
          <p class="unlimited mb-0">
            Propulsez votre <br />
            entreprise avec Internet <br />
            <span>haute vitesse illimité</span> <br />
          </p>
          <div class="create mt-3 mb-5">
            <button type="submit" class="btn signup-btn p-2 w-25">
              <a href="/civwifi/#/sign-up">S'inscrire</a>
            </button>
          </div>
        </div>

        <div class="col-md-6 mr-auto d-sm-block d-md-none">
          <p class="unlimited mb-0">
            Propulsez votre entreprise avec Internet{" "}
            <span>haute vitesse illimité</span>
          </p>
          <div class="create mt-3 mb-5">
            <button type="submit" class="btn signup-btn p-2 w-25">
              <a href="/civwifi/#/sign-up">S'inscrire</a>
            </button>
          </div>
        </div>

        <div class="col-md-6 family p-0 d-none d-md-block">
          <img
            src={man}
            class="img-fluid mt-5"
          />
        </div>
      </div>
      <div class="carrier3 carrier1 col-12 col-lg-11 ml-lg-5" id="whyGhana">
        <h5 class="ml-3">Ce que vous obtenez</h5>
        <div class="col-12 p-0 d-flex flex-wrap">
          <div class="col-12 col-md-4 mb-4">
            <div class="d-flex shadow bg-white p-3">
              <div class="mr-3 mt-2">
                <img
                  src="https://res.cloudinary.com/ghanawifi/image/upload/v1561818262/Uptime_orbyzp.png"
                  class="mt-4"
                />
              </div>
              <div>
                <h5>
                  <b>99 % de disponibilité </b>
                </h5>
                <p>
                  Nous veillons à ce que votre connexion soit rétablie avant
                  même que vous ne vous rendiez compte qu'il y a eu un temps
                  d'arrêt.
                </p>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-4 mb-4">
            <div class="d-flex shadow bg-white p-3">
              <div class="mr-3 mt-2">
                <img
                  src="https://res.cloudinary.com/ghanawifi/image/upload/v1561818261/techsupport_rpqrk2.png"
                  class="mt-4"
                />
              </div>
              <div>
                <h5>
                  <b>Soutien technique</b>
                </h5>
                <p>
                  Nous fournissons une assistance sur site et à distance pour
                  tous les problèmes techniques que vous pourriez avoir.
                </p>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-4 pr-0 mb-4 d-none d-md-block">
            <div class="d-flex shadow bg-white p-3">
              <div class="mr-3 mt-2">
                <img
                  src="https://res.cloudinary.com/ghanawifi/image/upload/v1561818261/speed_xwqajk.png"
                  class="mt-4"
                />
              </div>
              <div>
                <h5>
                  <b>Connectivité haut débit</b>
                </h5>
                <p>
                  Obtenez jusqu'à 10 Mbps de vitesse sur l'un de nos forfaits
                  professionnels et dédiés.
                </p>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-4 mb-4 d-sm-block d-md-none">
            <div class="d-flex shadow bg-white p-3">
              <div class="mr-3 mt-2">
                <img
                  src="https://res.cloudinary.com/ghanawifi/image/upload/v1560273301/Group_10_ylxiek.png"
                  class="mt-4"
                  alt="pic"
                />
              </div>
              <div>
                <h5>Connectivité haut débit</h5>
                <p>
                  Obtenez jusqu'à 10 Mbps de vitesse sur n'importe quel plan
                  d'affaires auquel vous vous abonnez.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="possibilities col-12 col-lg-11 ml-lg-5 mt-5 d-flex flex-wrap">
        <div class="col-md-6 mb-4">
          <h3>
            <span class="band">Technologie large </span> bande
          </h3>
          <p class="text-justify">
            CIVWifi offre un service Internet illimité en utilisant un
            équipement qui peut fournir des vitesses allant jusqu'à 300 Mbps
            bien au-dessus de la vitesse des autres technologies sans fil. Nous
            déployons 3 points d'accès 300 Mbps pour fournir une capacité
            gigabit qui rivalise ou dépasse les technologies filaires.
            <br />
            <br />
            Notre équipement une fois installé n'a pas besoin d'être remplacé ou
            mis à niveau pour augmenter la vitesse. Nos équipements sont « à
            l'épreuve du temps », vous n'aurez donc pas à vous soucier de la
            génération de technologie à utiliser. Avec d'autres fournisseurs,
            vous devez continuellement acheter de nouveaux équipements pour
            répondre à la demande Internet. Par exemple, dans une fenêtre de 3
            ans, vous avez payé deux fois pour la 2G, la 3G, la 4G (4G et 4G
            LTE) juste pour suivre le rythme, avec notre service, vous payez une
            fois et c'est tout ce dont vous avez besoin.
          </p>
        </div>

        <div class="col-md-6"></div>

        <div class="col-md-6"></div>

        <div class="col-md-6 mb-4">
          <h3>
            <span class="band">Lien</span> P2P dédié
          </h3>
          <p class="text-justify">
            Cela offre la meilleure expérience Internet; vous serez sur des
            radios sans fil dédiées de notre station de base à votre
            emplacement, assurant une optimisation maximale de la bande
            passante. Le forfait est un véritable forfait illimité sans limite
            de données ni limitation, vous pouvez diffuser et/ou télécharger
            autant de téraoctets que votre stockage le permet pendant la période
            de votre abonnement actif. La bande passante est adaptée en fonction
            de votre budget et de vos besoins, nous pouvons fournir de 1 Mbps à
            1 Go (internet gigabit).
          </p>
        </div>

        <div class="col-md-6">
          <h3>
            <span class="band">Redondance </span> avec basculement WAN
            automatique
          </h3>
          <p class="text-justify">
            Pour les clients qui disposent déjà d'un service Internet existant,
            nous pouvons fournir votre plan de secours ou de redondance. Cela
            garantit un temps d'arrêt de près de 0 %, car nous configurerons
            votre système pour qu'il bascule automatiquement vers notre
            approvisionnement lorsque votre source principale est en panne et
            que le service revient. Extrêmement idéal pour les bureaux critiques
            qui dépendent d'Internet pour un grand nombre de leurs fonctions.
          </p>
        </div>

        <div class="col-md-6"></div>
      </div>
      <div class="possibilities col-12 col-lg-11 ml-lg-5 mt-5">
        <h5 class="ml-3">Quelques cas d'utilisation</h5>
        <div class="d-flex flex-wrap p-0">
          <div class="col-md-3 mb-4">
            <div class="index-icon mb-4">
              <img
                alt="pic"
                src="https://res.cloudinary.com/ghanawifi/image/upload/v1561817225/Startups_jlclz1.png"
              />
            </div>
            <h5>Start-up</h5>
            <p>
              Notre service Internet dédié est idéal pour les startups de toutes
              tailles.
            </p>
          </div>

          <div class="col-md-3 mb-4">
            <div class="index-icon mb-4">
              <img
                alt="pic"
                src="https://res.cloudinary.com/ghanawifi/image/upload/v1560273301/Group_13_o1ntbc.png"
              />
            </div>
            <h5>Hôtels</h5>
            <p>
              Faites revenir vos précieux clients grâce à notre Internet
              illimité.
            </p>
          </div>

          <div class="col-md-3 mb-4">
            <div class="index-icon mb-4">
              <img
                alt="pic"
                src="https://res.cloudinary.com/ghanawifi/image/upload/v1560273301/Group_16_r78xq2.png"
              />
            </div>
            <h5>Restaurants</h5>
            <p>
              Augmentez le trafic vers vos points de restauration en offrant un
              accès Internet illimité à vos clients fidèles
            </p>
          </div>

          <div class="col-md-3 pr-0">
            <div class="index-icon mb-4">
              <img
                alt="pic"
                src="https://res.cloudinary.com/ghanawifi/image/upload/v1560273303/Group_12_wncnrv.png"
              />
            </div>
            <h5>Les établissements d'enseignement</h5>
            <p>
              Restez connecté avec nos plans dédiés aux établissements
              d'enseignement
            </p>
          </div>
        </div>
      </div>
      <PlanButtons />
      <Footer />
    </div>
  );
}

export default ForBusiness;
